<template>
  <el-container v-title data-title="换卡管理" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>换卡管理</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="换卡者用户名">
                  <el-input v-model="searchForm.applicantUserName" placeholder="换卡者用户名"></el-input>
                </el-form-item>
                <el-form-item label="学生姓名">
                  <el-input v-model="searchForm.studentRealName" placeholder="学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getChangeCardList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="applicantUserName" label="换卡者用户名" width="140"></el-table-column>
          <el-table-column prop="studentRealName" label="学生姓名" width="100"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="110"></el-table-column>
          <el-table-column prop="className" label="班级" width="80"></el-table-column>
          <el-table-column prop="remark" label="备注" width="600"></el-table-column>
          <el-table-column prop="insertTime" label="生成时间" width="170"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="80"></el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 1" type="text" @click="handle(scope.row.id)">处理</el-button>
              <el-button type="text" @click="openChangeCardThenNotifyDialog(scope.row)" v-if="scope.row.status == 1">处理并通知</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getChangeCardList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（处理并通知） -->
      <el-dialog
        title="处理并通知"
        :visible.sync="changeCardThenNotifyDialogVisible"
        width="420px"
        :before-close="handleClose">
        <el-form :model="changeCardThenNotifyForm" :rules="rulesOfChangeCardThenNotifyForm" label-width="90px">
          <el-input type="hidden" v-model="changeCardThenNotifyForm.orderId"></el-input>
          <el-form-item label="通知内容" prop="notifyContent">
            <el-input type="textarea" :rows="4" placeholder="请输入通知内容" v-model="changeCardThenNotifyForm.notifyContent">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleThenNotify(changeCardThenNotifyForm.id, changeCardThenNotifyForm.notifyContent)">确定</el-button>
            <el-button @click="changeCardThenNotifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {},
      schoolList: [],
      changeCardThenNotifyDialogVisible: false,
      changeCardThenNotifyForm: {},
      rulesOfChangeCardThenNotifyForm: {
        notifyContent: [{ required: true, message: '请输入消息内容', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
      this.getChangeCardList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getChangeCardList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getChangeCardList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/changeCard/list',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          applicantUserName: _this.searchForm.applicantUserName,
          studentRealName: _this.searchForm.studentRealName,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    handle (id) {
      let _this = this
      this.$confirm('确认要进行处理？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/changeCard/handle',
          this.$qs.stringify({
            id: id
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              _this.getChangeCardList()
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    openChangeCardThenNotifyDialog (changeCard) {
      this.changeCardThenNotifyForm = {
        id: changeCard.id,
        notifyContent: '已安排制卡，3-5个工作日送达学校，请提醒孩子带卡到校等待更换。'
      }
      this.changeCardThenNotifyDialogVisible = true
    },
    handleThenNotify (id, notifyContent) {
      console.log('id: ' + id)
      console.log('notifyContent: ' + notifyContent)
      let _this = this
      this.$confirm('确认已处理吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/changeCard/handle',
          this.$qs.stringify({
            id: id,
            notifyContent: notifyContent
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                message: '已处理成功',
                type: 'success'
              })
              _this.changeCardThenNotifyDialogVisible = false
              _this.changeCardThenNotifyForm = {}
              _this.getChangeCardList()
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/ChangeCard.vue